<template>
  <no-ssr>
  <section class="people-section">
    <header-inner/>
    <wrapper :lineBorders="false" :lineCenter="true" class="page--top" >
    <about-menu @currentMenu="currentMenu($event)"/>
      <section class="content-people row-grid" v-show="peoplesloaded">
            <div class="col-md-4 col-xs-6 item" v-for="people in getPeopleList " :key="people.id">
               <div class="content">
                 <div class="img" v-if="people.image" @click="onLinkClick(people.id)">
                   <img :src="people.image"  class="size-2 cover"/>
                 </div>
                 <div class="img" v-else></div>
                 <div class="name" v-html="people.title"></div>
                 <div class="prof" v-html="people.post"></div>
                 <div class="description" v-html="people.department"></div>
               </div>
            </div>
      </section>

      <modal ref="peopleModal" :fixedHeader="false">
        <div class="people-modal" v-if="this.peopleloaded">
          <figure>
            <img :src="this.getPeopleOne.image" :alt="this.getPeopleOne.title">
            <figcaption>
              <h2 class="text-blue-2" v-html="getPeopleOne.title"></h2>
              <div class="post" v-html="getPeopleOne.position"></div>
            </figcaption>
          </figure>
          <article class="people-text typography-text" v-html="this.getPeopleOne.description"></article>
        </div>
      </modal>

    </wrapper>
  </section>
  </no-ssr>
</template>

<script>
  import HeaderInner from '~/components/header/HeaderInner'
  import Modal from '~/components/shared/Modal'
  import AboutMenu from '~/components/about/AboutMenu'
  export default {
      components: {
          HeaderInner,
          Modal,
          AboutMenu
      },
      data() {
         return {
           seoMenu: {
             title: null,
             description: null,
             keywords: null,
           },
          peopleCurrent: {
            name: "",
            post: "",
            image: "",
            text: "",
          },
          peoples: [
            {
              id: "1",
              title: "Сендеров Евгений Эрнестович",
              image: '/images/_tmp/senderov.jpg',
              text: "<p>Президент Russ outdoor</p>",
            },
            {
              id: "2",
              title: "Жан-Эммануэль де Витт",
              image: '/images/_tmp/de-witt.jpg',
              text: "<p>Управляющий директор Russ Outdoor</p>",
            },
          ],
        };
      },
    // SEO API
    async asyncData({ $axios, app, redirect, route, store, query }) {
      let seoPage = {}
      try {
        seoPage = await $axios.$get(`${process.env.apiUrl}/methods/site/get_page_info/?link=${route.path}`,
                {
                  timeout: 1000 * 5, // Wait for 5 seconds
                }
        );
        return {seoPage}
      } catch (e) {
        seoPage = {id:  '', title: '', description: '', keywords: ''}
        return {seoPage};
      }
    },
    head () {
      if(this.seoPage) {
        return {
          title: this.seoPage.title,
          link: [{rel: 'canonical', href: process.env.base + this.$route.path}],
          meta: [
            {
              hid: `description`,
              name: `description`,
              content: this.seoPage.description
            },
            {
              hid: `keywords`,
              name: 'keywords',
              content: this.seoPage.keywords
            }
          ]
        }
      }
    },
      methods: {
        onLinkClick(itemID) {
         // console.log('onLinkClick', itemID);
          this.$store.dispatch('company/peopleOne', itemID);
          this.$refs.peopleModal.toggle(true);
        },
        currentMenu(event) {
          this.seoMenu.title = event.title
          this.seoMenu.description = event.description
          this.seoMenu.keywords = event.keywords
        }
      },
      computed: {
        getPeopleList() {
          return this.$store.getters['company/peopleList']['items']
        },
        peoplesloaded() {
          return this.$store.getters['company/peopleList']['loaded']
        },

        getPeopleOne() {
          return this.$store.getters['company/peopleOne']['item']
        },
        peopleloaded() {
          return this.$store.getters['company/peopleOne']['loaded']
        }
      },

      mounted() {
        if(!this.getPeopleList.length) this.$store.dispatch('company/peopleList');
      }

  };
</script>

<style lang="scss" scoped>
  @import "../../assets/vars", "../../assets/mixins";

  .content-people {
      margin: 0 -60px 40px;

      .item {
        padding: 0 60px;
        margin-bottom: 60px;
         .content {

            @include font-size(18px,28px);
            .img {
               padding-bottom: 100%;
               background: #bababa;
               position: relative;
               cursor: pointer;
               img {
                  @include position-full();
                 // min-height: 100%;
               }

            }
            .name {
              font-weight: bold;
              font-size: 24px;
              padding: 30px 0px 10px;
            }
            .prof {
              font-weight: bold;
            }
           .description {
              padding-top: 10px;
           }
         }
      }
      @media (max-width: $media_md) {
         margin: 0 -30px 40px;
         .item {
            padding: 0 30px;

            margin-bottom: 30px;
            .content {
              font-size: 16px;
              .name {
                padding: 10px 0px;
                font-size: 22px;
              }
            }
          }
      }

      @media (max-width: $media_xs) {
         margin: 0 -10px 40px;
         .item {
             padding: 0 10px;
             margin-bottom: 30px;
          .content {
            font-size: 14px;
            .name {
              padding: 5px 0px;
              font-size: 16px;
            }
          }
        }
      }
   }

  .people-modal {
    padding: 30px 0;
    @media (max-width: 600px) {
      padding: 15px 0;
    }
    figure {
      width: 490px;
      max-width: 100%;
      img {
        width: 100%;
        max-width: 340px;
      }
      figcaption {
        padding: 40px 0;
        @media (max-width: 600px) {
          padding: 20px 0;
        }
        h2 {
          padding: 0 0 10px;
        }
        .post {
          @include font-size(16px, 32px);
          text-transform: uppercase;
        }
      }
    }
    .people-text {
      border-top: 5px solid $color-text;
      padding: 45px 0 0;
      @media (max-width: 600px) {
        padding: 25px 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/company/people.vue